export default __webpack_public_path__ + "static/media/avatar_cheshire_cat3.94865419.mp3";